import styled from "styled-components";

export const BreadCrumbsWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const ActiveCrumbs = styled.p`
    color: #141823;
`;

export const Crumbs = styled.a`
    margin-right: 8px;
`;

export const Icon = styled.span`
    margin-left: 8px;
    color: #2276e3;
`;